document.addEventListener('DOMContentLoaded', function () {
  var packageField = document.getElementById('EnquirePackageField');
  var messageField = document.getElementById('ContactFormMessage');

  document.querySelectorAll('[data-enquire-package]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var packageName = btn.getAttribute('data-enquire-package');
      if (packageField) packageField.value = packageName;
      if (messageField && !messageField.value) {
        messageField.value = 'Interested in: ' + packageName + '\n';
      }
    });
  });

  // Make package cards keyboard-openable (Enter/Space) since the hover
  // reveal also responds to :focus-within on the card itself.
  document.querySelectorAll('.package-card').forEach(function (card) {
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var enquireLink = card.querySelector('.package-card__enquire');
        if (enquireLink && document.activeElement === card) {
          e.preventDefault();
          enquireLink.click();
        }
      }
    });
  });
});
